import { render } from "./Navbar2.vue?vue&type=template&id=cad61dda&scoped=true"
import script from "./Navbar2.vue?vue&type=script&lang=js"
export * from "./Navbar2.vue?vue&type=script&lang=js"

import "./Navbar2.vue?vue&type=style&index=0&id=cad61dda&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad61dda"]])

export default __exports__